import { handleActions } from 'redux-actions';
import setLoading from 'actions/loading';

const loading = false;

const reducer = handleActions(
  {
    [setLoading as any]: (_, action) => action.payload,
  },
  loading
);

export default reducer;
